module.exports = __webpack_public_path__ + "media/images/front/icon_review_yj_l-1f8e398c0897020757d96d2f35bf73f3.png";